// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.eq-b-container {
  position: fixed;
  right: 100%;
  top: 0%;
  z-index: 99;
}

#equation-bar,
.equation-bar {
  display: grid;
  grid-gap: 6px;
  grid-template-columns: 32px auto;
  height: 32px;
  padding: 4px 8px;
}

#fxButton {
  font-size: 1em;
  font-weight: 600;
  border-radius: 4px;
  border: 2px;
  cursor: pointer;
}
#fxButton:hover {
  background-color: rgba(0, 0, 0, 0.2);
}

#fxButton:disabled {
  cursor: not-allowed;
}

#equationInput {
  border: 1px solid #dfe0e1;
  padding: 0 8px;
  border-radius: 6px;
  color: #505050;
  font-family: Helvetica, sans-serif !important;
  font-size: 0.76rem;
}

.bg-blue {
  background-color: lightblue;
}

.bg-pink {
  background-color: lightcoral;
}

kendo-window {
  border-radius: 4px !important;
}

:host ::ng-deep kendo-window-titlebar,
:host ::ng-deep .k-dialog-titlebar,
:host ::ng-deep .k-window-titlebar {
  background-color: #51738b !important;
  padding: 0.25rem 0.5rem !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/model-data/equations/equation-bar/equation-bar.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,WAAA;EACA,OAAA;EACA,WAAA;AACF;;AAEA;;EAEE,aAAA;EACA,aAAA;EACA,gCAAA;EACA,YAAA;EACA,gBAAA;AACF;;AAGA;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;AAAF;AACE;EACE,oCAAA;AACJ;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,cAAA;EACA,6CAAA;EACA,kBAAA;AAAF;;AAGA;EACE,2BAAA;AAAF;;AAEA;EACE,4BAAA;AACF;;AAEA;EACE,6BAAA;AACF;;AAEA;;;EAGE,oCAAA;EACA,kCAAA;AACF","sourcesContent":[".eq-b-container {\r\n  position: fixed;\r\n  right: 100%;\r\n  top: 0%;\r\n  z-index: 99;\r\n}\r\n\r\n#equation-bar,\r\n.equation-bar {\r\n  display: grid;\r\n  grid-gap: 6px;\r\n  grid-template-columns: 32px auto;\r\n  height: 32px;\r\n  padding: 4px 8px;\r\n  // width: calc(100% - 30px);\r\n}\r\n\r\n#fxButton {\r\n  font-size: 1em;\r\n  font-weight: 600;\r\n  border-radius: 4px;\r\n  border: 2px;\r\n  cursor: pointer;\r\n  &:hover {\r\n    background-color: rgba($color: #000000, $alpha: 0.2);\r\n  }\r\n}\r\n\r\n#fxButton:disabled {\r\n  cursor: not-allowed;\r\n}\r\n\r\n#equationInput {\r\n  border: 1px solid #dfe0e1;\r\n  padding: 0 8px;\r\n  border-radius: 6px;\r\n  color: #505050;\r\n  font-family: Helvetica, sans-serif !important;\r\n  font-size: 0.76rem;\r\n}\r\n\r\n.bg-blue {\r\n  background-color: lightblue;\r\n}\r\n.bg-pink {\r\n  background-color: lightcoral;\r\n}\r\n\r\nkendo-window {\r\n  border-radius: 4px !important;\r\n}\r\n\r\n:host ::ng-deep kendo-window-titlebar,\r\n:host ::ng-deep .k-dialog-titlebar,\r\n:host ::ng-deep .k-window-titlebar {\r\n  background-color: #51738b !important;\r\n  padding: 0.25rem 0.5rem !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
